module.exports = "/static/assets/40d59a6d36dd479f7934cc35c3f6f795.png";